import React, { useState } from 'react';
import { StyledTopBarContainer, StyledSelect, StyledOption, StyledStyleImage, StyledStyledTitle, StyledStyledSortTitle, StyledTopBarWrapper } from './TopBar.styled';
import CardStyleImage from "../../../assets/images/card_style.png"
import CardStyleActiveImage from "../../../assets/images/card_style_active.png"
import ListStyleImage from "../../../assets/images/list_style.png"
import ListStyleActiveImage from "../../../assets/images/list_style_active.png"

interface Props {
    setStyle: (value: string) => void
    style: string
}

const TopBar = (props: Props) => {
    return (
        <StyledTopBarContainer>
            <StyledTopBarWrapper>
                <StyledStyledTitle>BlackJack Tables</StyledStyledTitle>
                {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <StyledStyledSortTitle>Sort by: </StyledStyledSortTitle>
                    <StyledSelect>
                        <StyledOption>Player Number</StyledOption>
                        <StyledOption>Latest</StyledOption>
                    </StyledSelect>
                </div> */}
            </StyledTopBarWrapper>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
                <StyledStyleImage src={props.style == "card" ? CardStyleActiveImage : CardStyleImage} alt="Card Style" onClick={() => props.setStyle("card")} />
                <StyledStyleImage src={props.style == "list" ? ListStyleActiveImage : ListStyleImage} alt="List Style" onClick={() => props.setStyle("list")} />
            </div>
        </StyledTopBarContainer>
    );
}

export default TopBar;
